import { convertShortInfoEntry } from './common';
import { SimplifiedFacilityTypes, FacilityTypes } from '../../types';
import {
  SimplifiedFacilityResponseTypes,
  FacilityResponseTypes,
} from '../../types/response/facility';
import { checkValidUrl } from '../shareLinkUtils';
import { removeUndefined } from '../formatUtils';

export const convertSimplifiedFacilityResponse = (
  item: SimplifiedFacilityResponseTypes
): SimplifiedFacilityTypes => {
  const { shortInformation, introduction, information } = convertShortInfoEntry(item.shortInfo);
  const convertItem: SimplifiedFacilityTypes = {
    id: item.id,
    code: item.code,
    name: item.name,
    icon: item.icon,
    image: item.avatar,
    iconBgColor: item.iconBgColor,
    address: item.address,
    description: item.description,
    zoneCoords: item.zoneCoords,
    zoneColor: item.zoneColor,
    labelColor: item.labelColor,
    labelCoords: item.labelCoords,
    transparent: item.transparent,
    labelTransparent: item.labelTransparent,
    shortInformation,
    introduction,
    information,
    alias: item.alias,
    media: item.gallery,
    isSimplified: true,
    virtualTourUrl: checkValidUrl(item.virtualTourUrl) ? item.virtualTourUrl : undefined,
    numberOfFacilities: item.numberOfFacilities,
    numberOfGallery: item.numberOfGallery,
    orderIndex: item.orderIndex,
  };
  // remove all key with undefined value in convertItem object
  return removeUndefined(convertItem);
};

export const convertFacilitiesResponse = (item: FacilityResponseTypes): FacilityTypes => {
  const facility = convertSimplifiedFacilityResponse(item);
  const { facilityGroup, children } = item;
  return {
    ...facility,
    parent: facilityGroup && convertSimplifiedFacilityResponse(facilityGroup),
    parentId: facilityGroup && facilityGroup.id,
    facilityCodes: children && children.map((child) => child.code),
    isSimplified: false,
  };
};
